// extracted by mini-css-extract-plugin
export var addressFields = "_is-0";
export var animationContainer = "_is-1";
export var footer = "_is-2";
export var lineItems = "_is-3";
export var modalContent = "_is-4";
export var orderName = "_is-5";
export var strong = "_is-6";
export var warning = "_is-7";